export enum ContactTypeEnum {
  Email = 1,
  Phone = 2
}
